export default __webpack_public_path__ + "static/media/host_screenShare.45e63941.svg";